import { Card } from "@/components/ui/card";
import { Mic } from "lucide-react";
import { SectionHeader } from "@/components/meeting/SectionHeader";

export function formatTimestamp(s) {
  const m = Math.floor(s / 60).toString().padStart(2, "0");
  const sec = Math.floor(s % 60).toString().padStart(2, "0");
  return `${m}:${sec}`;
}

export const TranscriptTab = ({ transcript }) => (
  <Card className="p-8 bg-af-subtle border-af rounded-md" data-testid="transcript-card">
    <SectionHeader icon={Mic} title="Transcription complète" subtitle={`Langue : ${transcript.language?.toUpperCase()}`} />
    <div className="space-y-4 max-h-[600px] overflow-y-auto pr-2">
      {transcript.segments.map((seg, i) => (
        <div key={`${seg.start}-${i}`} className="flex gap-4 pb-3 border-b border-af last:border-0">
          <div className="font-mono text-xs text-af-muted w-16 shrink-0 pt-0.5">
            {formatTimestamp(seg.start)}
          </div>
          <div className="flex-1">
            <div className="text-xs font-semibold text-terracotta mb-1">{seg.speaker}</div>
            <div className="text-sm text-af leading-relaxed">{seg.text}</div>
          </div>
        </div>
      ))}
    </div>
  </Card>
);
